exports.ByName = {
  IncomeStatement: { Id: 1, Name: 'financial_area.income_statement' },
  BalanceSheet: { Id: 2, Name: 'financial_area.balance_sheet' }
};

exports.ById = {
  1: { Id: 1, Name: 'financial_area.income_statement' },
  2: { Id: 2, Name: 'financial_area.balance_sheet' }
};
